
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { RoleItemProps } from ".";
import { loading, update } from "store/role";
import { AppMessage } from "components";

interface ApiRoleUpdateInputProps extends RoleItemProps {
}

type ApiRoleUpdateOutputProps = OutputBaseProps<{ item: RoleItemProps; }, ApiRoleUpdateInputProps>

export const apiRoleUpdate = async (data: ApiRoleUpdateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.put<ApiRoleUpdateOutputProps>("/api/role/update", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(update({ data: res.data.item }));
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};